(() => {
  const setup = (section) => {
    if (section.dataset.brioVideoReady) return;
    const video = section.querySelector('.brio-hero-video');
    const media = section.querySelector('.brio-hero-video-media');
    if (!video || !media) return;
    section.dataset.brioVideoReady = 'true';
    video.muted = true;
    video.defaultMuted = true;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false, requested = false, revealed = false, revealing = false, resumeTimer;
    const canPlay = () => inView && !reducedMotion.matches && !document.hidden;
    const play = () => {
      if (revealed && canPlay()) video.play().catch(() => {});
    };
    const finishReveal = () => {
      if (revealed || !revealing) return;
      clearTimeout(resumeTimer);
      revealed = true; revealing = false;
      play();
    };
    video.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'opacity') finishReveal();
    });
    const showOpeningFrame = () => {
      if (revealed || revealing || !canPlay() || video.seeking || video.readyState < 2) return;
      // Keep the decoded opening frame still during the handoff from its poster.
      // Playback starts only after the video is completely visible.
      revealing = true;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        media.classList.add('is-playing');
        resumeTimer = setTimeout(finishReveal, 900);
      }));
    };
    const sync = () => {
      if (!canPlay()) { video.pause(); return; }
      if (!requested) {
        requested = true;
        // Choose the matching clip explicitly; older mobile browsers do not
        // consistently apply media queries on video <source> elements.
        const source = [...video.querySelectorAll('source')].find(el => !el.media || matchMedia(el.media).matches);
        if (source) video.src = source.src;
        video.preload = 'auto';
        video.load();
      }
      if (revealed) play();
      else showOpeningFrame();
    };
    video.addEventListener('loadeddata', showOpeningFrame);
    video.addEventListener('canplay', showOpeningFrame);
    video.addEventListener('seeked', showOpeningFrame);
    reducedMotion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        inView = entries[0]?.isIntersecting ?? false;
        sync();
      }, {threshold: .1}).observe(section);
    } else { inView = true; sync(); }
  };
  const start = () => document.querySelectorAll('.brio-hero-layered--video').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
